var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98762 13.946C2.93716 13.946 0.464355 11.4732 0.464355 8.42278C0.464355 6.58218 1.20609 5.46469 2.7498 3.94928C3.73821 2.97897 4.66331 1.78722 5.05648 0.975724C5.13389 0.815974 5.31004 -0.0165085 5.98923 0.95822C6.34553 1.46942 6.90406 2.37855 7.26222 3.15444C7.87963 4.49217 8.02698 5.78861 8.02698 5.78861C8.02698 5.78861 8.63207 5.43206 9.04666 4.51401C9.18032 4.21813 9.45054 3.09802 10.2059 4.21797C10.7602 5.03983 11.5217 6.51751 11.5109 8.42278C11.5109 11.4732 9.03799 13.946 5.98762 13.946Z",
    fill: "#FC9502"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.07259 7.91284C6.85859 7.91284 6.85859 9.36835 7.85703 11.3118C8.52186 12.6058 7.52741 13.9459 6.07259 13.9459C4.61776 13.9459 3.86328 12.7666 3.86328 11.3118C3.86328 9.85703 5.28658 7.91284 6.07259 7.91284Z",
    fill: "#FCE202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallFire);
export default __webpack_public_path__ + "static/media/small_fire.1558454f42845b33452ddaa95b9a7771.svg";
export { ForwardRef as ReactComponent };